import { Route, Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import superAdminList from "./superadmins.json"

const PrivateRoute = ({ component: Component, ...rest }) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    let loggedInEnterpriseId = "";
    if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

    return (
        <>
                <Route
                    {...rest}
                    render={props =>
                        superAdminList.includes(loggedInEnterpriseId) ? (
                            <Component {...props} />
                        ) : <Navigate to="/access-denied" replace />}
                />
        </>
    );
};

export default PrivateRoute;
